import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Errors } from "../core/models/errors.module";
import { AuthService } from "../core/services/auth.service";
import { CommonService } from "../core/services/common.service";
import { JwtService } from "../core/services/jwt.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html"
})
export class LoginComponent implements OnInit {
  title: String = "";
  errors: Errors = new Errors();
  isSubmitting = false;
  authForm: FormGroup;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private fb: FormBuilder,
    private commonService: CommonService,
    private jwtService: JwtService
  ) {
    this.authForm = this.fb.group({
      email: ["", Validators.required],
      password: ["", Validators.required]
    });
  }

  ngOnInit() {
    this.route.url.subscribe(data => {
      this.title = "Sign in";
    });
  }

  submitForm() {
    // this.isSubmitting = true;
    this.errors = new Errors();

    const email = this.authForm.controls.email.value;
    const password = this.authForm.controls.password.value;

    this.authService.login(this.authForm.value).subscribe(
      response => {
        if (response["code"] == 422) {
          this.commonService.notifications.error(
            "Login Failed",
            "Invalid Username / Password"
          );
        }
        // login successful if there's a jwt token in the response
        const token = response.token;

        if (token) {
          // store jwt token in local storage to keep user logged in between page refreshes
          this.jwtService.saveToken(token);

          this.router.navigateByUrl("/home").then(() => {
            window.location.reload();
          });
        }
      },
      err => {
        this.errors = err;
        this.isSubmitting = false;
      }
    );
  }

  forgotPassword() {
    this.router.navigateByUrl("/forgot-password");
  }
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/login/login.component.ts